import PageTitle from './PageTitle'
import ButtonLinkHover from './ButtonLinkHover';
import ProjectCardSmall from './project/ProjectCardSmall'
import PrephysicianCardSmall from './prephysician/PrephysicianCardSmall'


export default function Home (props){


return(
  <div style={{display: 'flex'}}>
    <div style={{width: '7vw'}}></div>
    <div style={{width: '86vw', marginBottom: '150px'}}>
		<div>
			<PageTitle
        pageTitle = 'Home sweet home!'
        />    
		</div>
    <div style = {{
        display: 'flex',
        flexFlow: 'wrap',
        justifyContent: 'center',
      }}>
        <div style={{
          width: '320px',
          margin: "20px",
          }}>
          <p style={{
            color: "#FFF",
            textAlign: 'center',
            fontSize: '1.5rem',
            fontWeight: "600",
            margin: "0",
          }}>
            Your Cards
          </p>

              <div style = {{
                display: 'flex',
                flexFlow: 'row wrap',
              }}>
                {
                  (
                    props.projectUserData &&
                    props.projectUserData.map(p => (
                      <ProjectCardSmall
                        key={p.project_id}
                        project_id={p.project_id}  
                        specialty={p.specialty}
                        institution={p.institution}
                        completion={p.completion}
                        projectModal={props.projectModal}
                        setProjectModal={props.setProjectModal}
                      />
                    ))
                  )
                }     
              </div>
              <div style = {{
                display: 'flex',
                flexFlow: 'row wrap',
              }}>
                {
                  (
                    props.prephysicianUserData &&
                    props.prephysicianUserData.map(p => (
                      <PrephysicianCardSmall
                        key={p.prephysician_id}
                        prephysician_id={p.prephysician_id}  
                        formal_name={p.formal_name}
                        state_name={p.state_name}
                        institution={p.institution}
                        skills={p.skills}
                        prephysicianModal={props.prephysicianModal}
                        setPrephysicianModal={props.setPrephysicianModal}
                      />
                    ))
                  )
                }     
              </div>
 
          <div 
            style={{
              display: 'flex', 
              justifyContent: 'center',
              margin: "30px 0 0 0",
              }}>
            <div style={{width: '280px'}}>
            {
              (props.userData &&
              props.userData[0].user_type === 'resident')
              ? <ButtonLinkHover
                  pageRef='/projectnew'
                  buttonName='Add a Project'
                />
              : (props.userData &&
                props.prephysicianUserData.length < 1 &&
                props.userData[0].user_type === 'prephysician')
                ? <ButtonLinkHover
                    pageRef='/prephysiciannew'
                    buttonName='Add Your Profile'
                  />
                : null       
            }
            </div>
          </div>
        </div>
        <div style={{
          width: '320px',
          margin: "20px",
          }}>
          <p style={{
            color: "#FFF",
            textAlign: 'center',
            fontSize: '1.5rem',
            fontWeight: "600",
            margin: "0",
          }}>
            Messages
          </p>
        </div>
    </div>
  </div>
  <div style={{width: '7vw'}}></div>

  </div>

  )
}



// <PageSubtitle
//         pageSubtitle = 'These are the cards you have made or commented on'
//         />   


// <div style={{
//   width: '320px',
//   margin: "20px",
//   }}>
//   <p style={{
//     color: "#FFF",
//     textAlign: 'center',
//     fontSize: '1.5rem',
//     fontWeight: "600",
//     margin: "0",
//   }}>
//     Other stuff
//   </p>
// </div>